import React from 'react';
import { Header, Profile } from '@cimpress/react-components';

import auth from './auth';

const Head = () => (
    <Header
        appTitle='Documents Apis'
        profile={
            <Profile
                profile={auth.getProfile()}
                isLoggedIn={auth.isLoggedIn()}
                onLogInClicked={() => auth.login()}
                onLogOutClicked={() => auth.logout('/')}
            />
        }
    />
);

export default Head;



// WEBPACK FOOTER //
// ./src/header.jsx